import React, { useContext, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { Container } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { useApolloClient } from '@apollo/client';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import RootContext from '../../../../util/root.context';
import EirHandsetContainer from '../../eir-handset-details/EirHandsetContainer';
import NavBar from '../../eir-nav-bar/NavBar';
import ApiFailureModal from '../../eir-error-modal/ApiFailureModal';
import ErrorModal from '../../eir-error-modal/ErrorModal';
import { useToggle } from '../../../hooks/useToggle';
import getGeneralImage from '../../../../util/getGeneralImage';
import { onPageLoad, onPageLoadWhenVarientChanges } from './handsetDetails.util';
import useLocalStorage from '../../../hooks/useLocalStorage';

/**
 * @function PrepayHandsetDetailsContainer - Component to display Handset details
 * @param {object} cmsData - Strapi Data
 * @returns {JSX.Element} - Returns PHandset details Element
 */
const PrepayHandsetDetailsContainer = ({ cmsData, cmsDataPrepay }) => {
  const [showLoader, setShowLoader] = useState({ code: ' ', value: false });
  const [addingTariff] = useState(false);
  const router = useRouter();
  const localStore = useLocalStorage();
  const { publicRuntimeConfig } = getConfig();
  const theme = useTheme();
  const showModal = useToggle(false);
  const showSessionExpiredModal = useToggle(false);
  const [title, setTitle] = useState(router.query.title);
  const [loading, setLoading] = useState({ offerData: true });
  const [state, setState] = useState({
    offers: [],
    discounts: [],
    selectedOfferId: null,
    selectedMobileOffer: null,
    simOnly: false,
  });
  const graphql = useApolloClient();
  const openAPIFailureModal = useToggle(false);
  const [openError, setOpenError] = useState(false);
  const [errorModalOccurence, setErrorModalOccurence] = useState(0);
  const errorModalMaxOccurence = 1;
  const errorModal = useToggle(false);
  const [onLoadError, setOnLoadError] = useState(false);
  const { state: rootState, dispatch } = useContext(RootContext);
  const [handsetCode, setHandsetCode] = useState('');
  const [handsetNotFound, setHandsetNotFound] = useState(false);
  const [mobileOffersIncart, setMobileOffersIncart] = useState(0);
  const [coUpgradeButton, setCoUpgradeButton] = useState(false);
  const [showInsurance, setShowInsurance] = useState(false);

  const handleOk = () => {
    openAPIFailureModal.disable();
  };

  const onHandsetDetailsLoad = async mobileHandsetCode => {
    onPageLoad({
      mobileHandsetCode,
      graphql,
      dispatch,
      localStore,
      errorModalOccurence,
      setOnLoadError,
      errorModal,
      openAPIFailureModal,
      setErrorModalOccurence,
      setLoading,
      setState,
      setOpenError,
      loading,
      state,
    });
  };

  const onLoadVaraintChange = async mobileHandsetCode => {
    onPageLoadWhenVarientChanges({
      mobileHandsetCode,
      graphql,
      dispatch,
      setState,
      localStore,
      setCoUpgradeButton,
      setLoading,
      loading,
      state,
    });
  };
  useEffect(() => {
    setTitle(router.query.title);
    setShowLoader(true);
    setMobileOffersIncart(
      rootState?.cart?.offers?.filter(offer => offer?.equipments?.length > 0).length
    );
  }, [router.query.title]);

  const backStep = async () => {
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile/prepay/handsets`);
  };

  return (
    <>
      {!handsetNotFound && (
        <NavBar
          forwardArrowIcon={
            <ArrowForward sx={{ m: 0, color: theme.palette.secondary.contrastText }} />
          }
          backArrowIcon={<ArrowBack sx={{ m: 0, color: theme.palette.secondary.contrastText }} />}
          backButtonText='Back'
          forwardButtonText='Checkout'
          headerText='2-3 day delivery after order completion'
          headerIcon={
            <LocalShippingIcon
              sx={{ color: theme.palette.primary.contrastText, mr: 1, fontSize: '1rem' }}
            />
          }
          backButtonOnClick={() => {
            backStep();
          }}
          nextButtonOnClick={() => {}}
          disableBack={false}
          disableNext
        />
      )}
      <Container
        maxWidth='100%'
        sx={{
          background:
            handsetNotFound &&
            `url(${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
              getGeneralImage({
                generalImageArray: cmsData?.data?.attributes?.generalImagesHandsetDetails,
                key: 'handset404Pagebg',
                view: 'MobileViewImage',
              }).url
            }) center/cover no-repeat`,
          backgroundColor: theme.palette.secondary.contrastText,
        }}
      >
        <EirHandsetContainer
          title={title}
          cmsData={cmsData}
          cmsDataPrepay={cmsDataPrepay}
          offers={state.offers}
          discounts={state.discounts}
          addingTariff={addingTariff}
          selectedOfferId={state.selectedOfferId}
          loading={loading.offerData}
          selectedBundle={state.selectedMobileOffer}
          showLoader={showLoader}
          setHandsetCode={setHandsetCode}
          handsetCode={handsetCode}
          setShowLoader={setShowLoader}
          OutOfStockImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
            getGeneralImage({
              generalImageArray: cmsData?.data?.attributes?.generalImagesHandsetDetails,
              key: 'outOfStockImage',
              view: 'MobileViewImage',
            }).url
          }`}
          OutOfStockImgAlt={
            getGeneralImage({
              generalImageArray: cmsData?.data?.attributes?.generalImagesHandsetDetails,
              key: 'outOfStockImage',
              view: 'MobileViewImage',
            }).alt
          }
          handsetNotFound={handsetNotFound}
          setHandsetNotFound={setHandsetNotFound}
          onPageLoadWhenVarientChanges={onLoadVaraintChange}
          mobileOffersIncart={mobileOffersIncart}
          setMobileOffersIncart={setMobileOffersIncart}
          coUpgradeButton={coUpgradeButton}
          setShowInsurance={setShowInsurance}
          showInsurance={showInsurance}
          onPageLoad={onHandsetDetailsLoad}
        />
      </Container>
      {openError && errorModalOccurence > errorModalMaxOccurence && (
        <ApiFailureModal openAPIFailureModal={openAPIFailureModal} handleOk={handleOk} />
      )}

      {errorModal.value && !showModal.value && !showSessionExpiredModal.value && (
        <ErrorModal
          errorBBModal={errorModal}
          occurences={errorModalMaxOccurence}
          currentOccurence={errorModalOccurence}
          ctaMethod={onLoadError ? onHandsetDetailsLoad : () => {}}
        />
      )}
    </>
  );
};

export default PrepayHandsetDetailsContainer;
